import { inject, Pipe, type PipeTransform } from '@angular/core';
import { WindowService } from '@big-direkt/utils/environment';

@Pipe({
    name: 'highlight',
})
export class HighlightPipe implements PipeTransform {
    private readonly windowService = inject(WindowService);

    public transform(text?: string, slug?: string): string | undefined {
        if (!text || !slug) {
            return undefined;
        }

        const content = this.windowService.document().createTextNode(slug);
        const highlighted = this.windowService.document().createElement('span');
        highlighted.appendChild(content);

        return text.replaceAll(new RegExp(slug, 'ig'), (value: string) => `<strong>${this.escape(value)}</strong>`);
    }

    private escape(htmlStr: string): string {
        return htmlStr.replaceAll(/&/g, '&amp;').replaceAll(/</g, '&lt;').replaceAll(/>/g, '&gt;').replaceAll(/"/g, '&quot;').replaceAll(/'/g, '&#39;');
    }
}
